export const hmplusGlobalReleaseConstants = {
  HMPLUS_GLOBAL_RELEASE_LOADING: "HMPLUS_GLOBAL_RELEASE_LOADING",
  HMPLUS_GLOBAL_RELEASE_SUCCESS: "HMPLUS_GLOBAL_RELEASE_SUCCESS",
  HMPLUS_GLOBAL_RELEASE_FAILURE: "HMPLUS_GLOBAL_RELEASE_FAILURE",
};

export const addHMPLUSGlobalReleaseConstants = {
  ADD_HMPLUS_GLOBAL_RELEASE_LOADING: "ADD_HMPLUS_GLOBAL_RELEASE_LOADING",
  ADD_HMPLUS_GLOBAL_RELEASE_SUCCESS: "ADD_HMPLUS_GLOBAL_RELEASE_SUCCESS",
  ADD_HMPLUS_GLOBAL_RELEASE_FAILURE: "ADD_HMPLUS_GLOBAL_RELEASE_FAILURE",
};

export const editHMPLUSGlobalReleaseConstants = {
  EDIT_HMPLUS_GLOBAL_RELEASE_LOADING: "EDIT_HMPLUS_GLOBAL_RELEASE_LOADING",
  EDIT_HMPLUS_GLOBAL_RELEASE_SUCCESS: "EDIT_HMPLUS_GLOBAL_RELEASE_SUCCESS",
  EDIT_HMPLUS_GLOBAL_RELEASE_FAILURE: "EDIT_HMPLUS_GLOBAL_RELEASE_FAILURE",
};
